module.exports = __webpack_public_path__ + "img/stock3.d98fa516.png";